import { render, staticRenderFns } from "./transferInputRecord.vue?vue&type=template&id=398159c6&scoped=true"
import script from "./transferInputRecord.vue?vue&type=script&lang=js"
export * from "./transferInputRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398159c6",
  null
  
)

export default component.exports